// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"27468b7d","2114":"e2bb4a42"}[chunkId] + ".chunk.css";
};